<div class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover directory-list-table footable">
        <thead>
            <tr [ngClass]="{'noSort': data.length < 2}">
                <th></th>
                <th (click)="orderBy('suite.suiteNumber', $event)" class="footable-sorted">
                    Unit<span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="directoryService.buildings.length != 1"
                    (click)="orderBy('building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('lockerKeyCode', $event)">
                    Locker Spot<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('rentedOut', $event)">
                    Rented Out<span class="footable-sort-indicator"></span>
                </th>
                <th>Rented To</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data" (click)="toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.suiteNumber}}</td>
                <td *ngIf="directoryService.buildings.length != 1">{{item.buildingName}}</td>
                <td>{{item.lockerKeyCode}}</td>
                <td class="with-icon">
                    <i *ngIf="item.rentedOut" class="icon-check"></i>
                    <i *ngIf="!item.rentedOut" class="icon-close"></i>
                </td>
                <td>
                    <span *ngIf="!item.rentedOut || !item.extendedRentedTo.buildingName">-</span>
                    <span *ngIf="item.rentedOut">
                        {{item.extendedRentedTo.buildingName}}
                        {{item.extendedRentedTo.suiteNumber ? (', ' + item.extendedRentedTo.suiteNumber): ''}}
                        {{item.extendedRentedTo.suiteUserName ? (', ' + item.extendedRentedTo.suiteUserName): ''}}
                    </span>
                </td>
            </tr>
            <tr *ngFor="let item of emptyRowService.emptyRow" style="cursor: default;">
                <td><div class="psevdo-checkbox"></div></td>
                <td></td>
                <td *ngIf="directoryService.buildings.length != 1"></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message
            [isEmpty]="!directoryService.directoryData['lockers'].total"
            [isServiceUnavailable]="directoryService.showServiceUnavailable"
            [isLoading]="directoryService.spinnerShow">
        You have no lockers listed on the system<br>
        <span *ngIf="directoryService.account.canUpdate('bldn')">
            <a href="javascript://" (click)="directoryService.showModal()" class="mtv-primary-color clickable-text">add a locker</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/lockers-list/lockers-list.component.html